import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import InputPassword from "@/components/ui/input/InputPassword.vue";
  import PasswordProgress from "@/components/ui/PasswordProgress.vue";
  import CheckboxInput from "@/components/ui/input/CheckboxInput.vue";
  import useVuelidate from "@vuelidate/core";
  import { email, helpers, required } from "@vuelidate/validators";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import { validatePassword } from "@/helpers/validation";
  import { UserRoles } from "@/enums/UserRoles";
  import { newPasswordError } from "@/constants/validation";
  import router from "@/router";

  interface Props {
    isOpen: boolean;
    message?: string;
    estate?:
      | undefined
      | {
          imgPath: string;
        };
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationModal',
  props: {
    isOpen: { type: Boolean, default: false },
    message: { default: "" },
    estate: { default: undefined }
  },
  emits: ["close", "login", "signUp"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;
  const isAgree = ref(false);
  const formFields = {
    firstName: "",
    lastName: "",
    password: "",
    email: "",
    role: UserRoles.CUSTOMER,
  };

  const form = reactive(Object.assign({}, formFields));
  const rules = {
    password: {
      required,
      validatePassword: helpers.withMessage(newPasswordError, validatePassword),
    },
    email: { required, email },
    firstName: { required },
    lastName: { required },
  };
  const v$ = useVuelidate(rules, form);

  function clearForm() {
    Object.assign(form, formFields);
  }
  async function submitForm() {
    if (isAgree.value) {
      v$.value.$touch();
      const isFormCorrect = await v$.value.$validate();

      if (!isFormCorrect) return;

      emits("signUp", form);
    }
  }
  function onAgree() {
    isAgree.value = !isAgree.value;
  }
  function close() {
    clearForm();
    resetVuelidateErrors(v$);
    emits("close");
  }
  function login() {
    clearForm();
    emits("login");
  }

const __returned__ = { emits, props, isAgree, formFields, form, rules, v$, clearForm, submitForm, onAgree, close, login, reactive, ref, Modal, InputPassword, PasswordProgress, CheckboxInput, get useVuelidate() { return useVuelidate }, get email() { return email }, get helpers() { return helpers }, get required() { return required }, get resetVuelidateErrors() { return resetVuelidateErrors }, get validatePassword() { return validatePassword }, get UserRoles() { return UserRoles }, get newPasswordError() { return newPasswordError }, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})